module.exports = __webpack_public_path__ + "img/unit_BlackMetallic.b42af85b.png";